import { render, staticRenderFns } from "./BillingMessage.vue?vue&type=template&id=4ba73f6c&"
import script from "./BillingMessage.vue?vue&type=script&lang=js&"
export * from "./BillingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports